// utils/areasApi.js
import apiClient from "./apiClient";

const AREAS_ENDPOINT =
  "/ijscui/probroker-admin/ceknvuhbd/cjwbhusb/protected/admin/areas";
// The endpoint paginates at 20 by default; every city fits well inside this.
const AREAS_PAGE_LIMIT = 2000;

// Catch-all bucket offered in the UI only — it is not a stored area.
export const OTHER_AREA = "Other Area";

// Areas are stored per city and per moduleType ("owner" | "broker" | "builder" |
// "requirement"), so both are needed to get the list a section should offer.
// Returns sorted area names with OTHER_AREA appended, or [] when none/failed.
export const fetchAreas = async (city, moduleType) => {
  const response = await apiClient("GET", AREAS_ENDPOINT, {
    city,
    moduleType,
    limit: AREAS_PAGE_LIMIT,
  });

  const docs = response?.data?.data?.docs;

  if (!response?.success || !Array.isArray(docs)) {
    console.error("Error fetching areas:", response?.error);
    return [];
  }

  const names = [
    ...new Set(
      docs
        .filter((doc) => doc?.isActive !== false)
        .map((doc) => String(doc?.name || "").trim())
        .filter(Boolean)
    ),
  ].sort((a, b) => a.localeCompare(b));

  return names.length > 0 ? [...names, OTHER_AREA] : [];
};
